import { useState, useEffect } from 'react';
import './PageLoaderFallback.css';

/**
 * Suspense fallback that shows a shimmer bar and, after a delay,
 * a short message for slow cold starts (e.g. Render + Vercel).
 */
export default function PageLoaderFallback({ label = 'Loading' }) {
  const [showSlowHint, setShowSlowHint] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowSlowHint(true), 6000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="layout__page-loader-wrapper" aria-label={label}>
      <div className="layout__page-loader" aria-hidden="true" />
      {showSlowHint && (
        <p className="layout__page-loader-slow-hint" aria-live="polite">
          First load can take 30–60 seconds while our server starts. Thanks for your patience.
        </p>
      )}
    </div>
  );
}
